export const PRE_SEATS = 'PRE_SEATS';
export const SEATS_ONLY = 'SEATS_ONLY';
export const TRUE_BUNDLING = 'TRUE_BUNDLING';